import React from 'react';
import DisplayGeojson, { Props } from './DisplayGeojson';

export const DisplayRegions: React.FC<Omit<Props, 'map'>> = (props) => {
  return <DisplayGeojson {...props} />;
};
